import React, { FC, useState } from 'react';

import { ActionBottomSheet, Button } from '$uikit';
import { IcCoin28, IcDollar24, IcToncoin40 } from '$assets';
import { CurrencyEnum } from '$store/models';
import { useTranslator } from '$hooks';

export interface CurrencyButtonProps {
  value: CurrencyEnum;
  onChange: (next: CurrencyEnum) => void;
}

const CURRENCIES: { value: CurrencyEnum; label: string; icon: React.ReactNode }[] = [
  { value: CurrencyEnum.EUR, label: 'EUR', icon: <IcDollar24 /> },
  { value: CurrencyEnum.TON, label: 'TON', icon: <IcToncoin40 /> },
  { value: CurrencyEnum.PLACE, label: 'PLACE', icon: <IcCoin28 /> },
];

const metaOf = (v: CurrencyEnum) =>
  CURRENCIES.find((c) => c.value === v) ?? CURRENCIES[0];

export const CurrencyButton: FC<CurrencyButtonProps> = ({ value, onChange }) => {
  const t = useTranslator();
  const [open, setOpen] = useState(false);
  const current = metaOf(value);

  const handleChange = (next: string) => {
    onChange(next as CurrencyEnum);
    setOpen(false);
  };

  return (
    <>
      <Button mode="secondary" size="extra-small" onClick={() => setOpen(true)}>
        {t('statistics_pro_currency_label')} · {current.label}
      </Button>

      <ActionBottomSheet
        isOpened={open}
        title={t('statistics_pro_currency_label')}
        onChange={handleChange}
        onClose={() => setOpen(false)}
        options={CURRENCIES.map((c) => ({
          value: c.value,
          label: c.label,
          icon: c.icon,
        }))}
      />
    </>
  );
};
